import React from "react";
import "./ticker.css";
import { useBanner } from "../../context/BannerContext";
import { icons } from "@a365/dsys";

const {
  Airplane,
  Island,
  MapPin,
  Mosque,
  Mountains,
  SuitcaseRolling,
} = icons;

const Ticker = () => {
  const { bannerData } = useBanner();

  // ticker news
  
  return (
    <div className="bg-bg-alt-primary font-semibold font-base leading-6 _py-[10px] w-full text-white text-center">
      {bannerData?.marquesina_top && (
        <div className="ticker-container">
          <div class="ticker-tape-container">
            <div class="ticker-tape space-x-0">
              <div className="flex gap-x-2 ">
                <Airplane
                  size={24}
                  weight="duotone"
                  className="text-icon-alt"
                />
                <Island size={24} weight="duotone" className="text-icon-alt" />
              </div>
              <div>{bannerData?.marquesina_top}</div>
              <div className="flex gap-x-2">
                <SuitcaseRolling
                  size={24}
                  weight="duotone"
                  className="text-icon-alt"
                />
                <Mountains
                  size={24}
                  weight="duotone"
                  className="text-icon-alt"
                />
              </div>
              <div>{bannerData?.marquesina_top}</div>
              <div className="flex gap-x-2">
                <MapPin size={24} weight="duotone" className="text-icon-alt" />
                <Mosque size={24} weight="duotone" className="text-icon-alt" />
              </div>
              <div>{bannerData?.marquesina_top}</div>
              <div className="flex gap-x-2">
                <Airplane
                  size={24}
                  weight="duotone"
                  className="text-icon-alt"
                />
                <Island size={24} weight="duotone" className="text-icon-alt" />
              </div>
              <div>{bannerData?.marquesina_top}</div>
              <div className="flex gap-x-2">
                <SuitcaseRolling
                  size={24}
                  weight="duotone"
                  className="text-icon-alt"
                />
                <Mountains
                  size={24}
                  weight="duotone"
                  className="text-icon-alt"
                />
              </div>
              <div>{bannerData?.marquesina_top}</div>
              <div className="flex gap-x-2">
                <MapPin size={24} weight="duotone" className="text-icon-alt" />
                <Mosque size={24} weight="duotone" className="text-icon-alt" />
              </div>
              <div>{bannerData?.marquesina_top}</div>
              <div className="flex gap-x-2">
                <Airplane
                  size={24}
                  weight="duotone"
                  className="text-icon-alt"
                />
                <Island size={24} weight="duotone" className="text-icon-alt" />
              </div>
              <div>{bannerData?.marquesina_top}</div>
            </div>
            <div class="ticker-tape space-x-0">
              <div className="flex gap-x-2">
                <Airplane
                  size={24}
                  weight="duotone"
                  className="text-icon-alt"
                />
                <Island size={24} weight="duotone" className="text-icon-alt" />
              </div>
              <div>{bannerData?.marquesina_top}</div>
              <div className="flex gap-x-2">
                <SuitcaseRolling
                  size={24}
                  weight="duotone"
                  className="text-icon-alt"
                />
                <Mountains
                  size={24}
                  weight="duotone"
                  className="text-icon-alt"
                />
              </div>
              <div>{bannerData?.marquesina_top}</div>
              <div className="flex gap-x-2">
                <MapPin size={24} weight="duotone" className="text-icon-alt" />
                <Mosque size={24} weight="duotone" className="text-icon-alt" />
              </div>
              <div>{bannerData?.marquesina_top}</div>
              <div className="flex gap-x-2">
                <Airplane
                  size={24}
                  weight="duotone"
                  className="text-icon-alt"
                />
                <Island size={24} weight="duotone" className="text-icon-alt" />
              </div>
              <div>{bannerData?.marquesina_top}</div>
              <div className="flex gap-x-2">
                <SuitcaseRolling
                  size={24}
                  weight="duotone"
                  className="text-icon-alt"
                />
                <Mountains
                  size={24}
                  weight="duotone"
                  className="text-icon-alt"
                />
              </div>
              <div>{bannerData?.marquesina_top}</div>
              <div className="flex gap-x-2 ">
                <MapPin size={24} weight="duotone" className="text-icon-alt" />
                <Mosque size={24} weight="duotone" className="text-icon-alt" />
              </div>
              <div>{bannerData?.marquesina_top}</div>
              <div className="flex gap-x-2">
                <Airplane
                  size={24}
                  weight="duotone"
                  className="text-icon-alt"
                />
                <Island size={24} weight="duotone" className="text-icon-alt" />
              </div>
              <div>{bannerData?.marquesina_top}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Ticker;
